import { atomWithReset } from 'jotai/utils';
import type { StyleObject } from 'styletron-react';
export type DrawerProps = {
  id?: string;
  title: () => React.ReactNode;
  description?: string;
  component: ({
    onClose
  }: {
    onClose?: () => void;
  }) => React.ReactNode;
  onClose: () => void;
  isOpen?: boolean;
  showDivider?: boolean;
  styles?: {
    containerStyles?: StyleObject;
    contentContainerStyles?: StyleObject;
    sideDrawerStyles?: StyleObject;
  };
};
export const drawerAtom = atomWithReset<DrawerProps>({
  id: '',
  title: () => '',
  description: '',
  component: () => null,
  onClose: () => {},
  isOpen: false,
  styles: {}
});